(function () {
  'use strict';

  /* @ngdoc object
   * @name vehicles
   * @description
   *
   */
  angular
    .module('events.vehicles', [
      'ui.router',
      'events.vehicles.list',
      'events.vehicles.view',
      'events.vehicles.edit',
      'events.vehicles.guests',
      'events.vehicles.deposits'
    ]);
}());
